export default __webpack_public_path__ + "static/media/1341.5edf57c0.png";